import React from 'react';

const DateFormatter = ({ dateString }) => {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        if (isNaN(date)) {
            return 'Invalid Date';
        }

        // Define options for date and time separately
        const dateOptions = { year: '2-digit', month: '2-digit', day: '2-digit' };
        const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString('de-DE', dateOptions);
        const formattedTime = date.toLocaleTimeString('de-DE', timeOptions);

        // Combine date and time into a single string
        return `${formattedDate} ${formattedTime}`;
    };

    return (
        <div>
            {formatDate(dateString)}
        </div>
    );
};

export default DateFormatter;